
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Order: all' },
  { id: 'true', name: 'Has order' },
  { id: 'false', name: 'Missing order' },
]

export default function HasOrderSelect(props) {
  return <Select allowClear={false} {...props} options={STATUSES} />
}
